var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload icon",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 65",
    cx: 5.61914,
    cy: 5.61914,
    r: 4.61914,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 387936480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 43",
    d: "M7.66992 5.61914L6.77176 4.59266C6.29627 4.04925 5.45091 4.04925 4.97542 4.59266V4.59266L4.07726 5.61914",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 131",
    d: "M5.875 4.33594L5.875 7.41536",
    stroke: "black",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.f949d91e69060ae20413db16b0082ee7.svg";
export { ForwardRef as ReactComponent };